import { filter } from 'lodash';
import { ClaimItemEntity, DocumentEntity } from '../entities/entities.types';
import { AppState } from '../root.reducer';
import { PendingInternalUpdate } from '../claim-item/claim-item.types';

export const getPendingClaimItemPreview = (state: AppState): PendingInternalUpdate | undefined =>
  state.claimItem.pendingInternalUpdate;

interface GetClaimItemsByClaimId {
  claimId?: string;
}

export const getClaimItemById = (state: AppState, id: string): ClaimItemEntity | undefined => {
  if (!state.entities.claimItem) return undefined;
  return state.entities.claimItem[id];
};

export const getClaimItemsByClaimId = (state: AppState, { claimId }: GetClaimItemsByClaimId): ClaimItemEntity[] => {
  if (!state.entities.claimItem) return [];

  if (!claimId) return [];

  const items = filter(state.entities.claimItem, item => item.claimId === claimId);

  return items.map(item => {
    return { ...item, amount: item.amount / 100 };
  });
};

export const getDocumentsForClaimItem = (state: AppState, id: string): DocumentEntity[] => {
  const claimItem = getClaimItemById(state, id);
  if (!claimItem) return [];
  const claimItemDocIds = claimItem.claimItemDocuments;
  const claimItemDocs = claimItemDocIds.map(id => state.entities.claimItemDocument[id]);
  return claimItemDocs.map(itemDoc => state.entities.document[itemDoc.document]);
};
